import LinkedInIcon from './LinkedInIcon';

export default LinkedInIcon;
